export default {
  setChartData(state, value) {
    state.chartData = value;
  },
  setQueryData(state, value) {
    state.queryData = value;
  },
  setBenchmarkCohortData(state, value) {
    state.benchmarkCohortData = value;
  },
  setSegmentDashboardData(state, value) {
    state.segmentDashboardData = value;
  }
};
